import { useCallback } from "react";
import { calculateAirconServiceCost } from "../api/aircon-service/aircon-service-api";
import { applyAdditionalDiscount } from "./ac-apply-additional-discount";

export const airconCostCalulator = (
    userId,
    requestCriteria, 
    serviceDate, 
    startTime, 
    endTime, 
    setServicingCost, 
    setRateAggregatorFactor, 
    setGasCost, 
    setServiceType, 
    setGasCount, 
    setServiceSummary, 
    setDiscountPercent, 
    setNewUserDiscountPercent,
    setOriginalCost,
    setOriginalServiceCost,
    setOriginalGasCost,
    setNewUserServicingCost,
    setNewUserGasCost,
    setIsLoading,
    setErrorContent,
    setIsSystemError,
    countryName
) => {
    return useCallback(async () => {
        if (requestCriteria.length === 0 || !serviceDate || !startTime || !endTime) return;

        try {
            setIsLoading(true)
            const response = await calculateAirconServiceCost(userId, JSON.stringify(requestCriteria), serviceDate, startTime, endTime, countryName);

            setOriginalCost(response.servicingCost + response.gasCost)
            
            setOriginalServiceCost(response.servicingCost)
            
            const discountPercent = response.discountPercent
            setDiscountPercent(discountPercent)

            let serviceCost = response.servicingCost - response.servicingCost * discountPercent / 100;            

            setServicingCost(Math.round((serviceCost + Number.EPSILON) * 100) / 100);   

            let gasCost = 0;
            if (response.gasCost > 0) {
                const originalGas = response.gasCost;
                setOriginalGasCost(originalGas)

                gasCost = originalGas - originalGas * discountPercent / 100;
                // gasCostAvg = applyAdditionalDiscount(gasCostAvg);
            }

            if (response.rateAggregatorFactor) {
                setRateAggregatorFactor(response.rateAggregatorFactor);
            } else {
                setRateAggregatorFactor("");
            }

            setGasCost(Math.round((gasCost + Number.EPSILON) * 100) / 100);

            setServiceType(response.serviceType);

            setGasCount(response.gasCount)
            
            setServiceSummary(response.serviceSummary)
            
            if(response.newUserDiscountPercent){
                setNewUserDiscountPercent(response.newUserDiscountPercent)

                let newUserServiceCost = response.servicingCost - response.servicingCost * (discountPercent +  response.newUserDiscountPercent)/ 100;
                setNewUserServicingCost(Math.round((newUserServiceCost + Number.EPSILON) * 100) / 100)

                if(response.gasCost > 0){
                    let newUserGasCost = response.gasCost - response.gasCost * (discountPercent +  response.newUserDiscountPercent)/ 100;
                    setNewUserGasCost(Math.round((newUserGasCost + Number.EPSILON) * 100) / 100)
                }
            } else {
                setNewUserDiscountPercent(0.00)
            }
                        
            //google quote conversion
            try {
                if(typeof gtag != "undefined") {                    
                    if (response.airconCount === 1) {
                        gtag('event', 'conversion', { 'send_to': 'AW-823304067/PWjjCIzG5IoYEIO_yogD' });
                    }
                    if (response.airconCount === 2) {
                        gtag('event', 'conversion', { 'send_to': 'AW-823304067/ZYC8CPqU54oYEIO_yogD' });
                    }
                    if (response.airconCount === 3) {
                        gtag('event', 'conversion', { 'send_to': 'AW-823304067/DaGlCMHa5IoYEIO_yogD' });
                    }
                    if (response.airconCount === 4) {
                        gtag('event', 'conversion', { 'send_to': 'AW-823304067/V_pdCPXb5IoYEIO_yogD' });
                    }
                    if (response.airconCount > 4) {
                        gtag('event', 'conversion', { 'send_to': 'AW-823304067/rwvxCNrV5ooYEIO_yogD' });
                    } 
                }
            } catch (err) {
                console.log(err)
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setIsLoading(false)
            setErrorContent({'header': "Error calculating charges", 'body': "Please reload the app and try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true)
        }

    }, [requestCriteria, serviceDate, startTime, endTime, setRateAggregatorFactor, countryName]);
}